<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :height="300"
      :columns="tableColumns"
      :loading="loading"
      size="mini"
      resizable
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <el-button-group>
            <el-button
              type="primary"
              size="mini"
              icon="el-icon-plus"
              @click="() => (visible = true)"
              class="mb-2"
              >{{ $l('form_add_score_btn') || '新增评分' }}</el-button
            >
          </el-button-group>
        </slot>
      </template>

      <template v-slot:defaultImgUrl="{ row }">
        <b-avatar
          :src="row.scoreImgUrl ? $osscdn(row.scoreImgUrl) : ''"
        ></b-avatar>
        <span class="ml-3">{{ row.scoreByName }}</span>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <b-button-group>
            <b-button
              :title="$l('INDEX.btn_tips_edit') || '编辑'"
              @click="openDetail(row.visitScoreCode)"
              :disabled="row.isOwner === 'N'"
              variant="outline-secondary"
              size="sm"
            >
              <b-icon-pencil></b-icon-pencil>
            </b-button>
            <b-button
              :title="$l('INDEX.btn_tips_del') || '删除'"
              :disabled="row.isOwner === 'N'"
              @click="del(row.visitScoreCode)"
              variant="outline-secondary"
              size="sm"
            >
              <b-icon-trash-fill></b-icon-trash-fill>
            </b-button>
          </b-button-group>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.tips_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>

    <add-score-dialog
      :visible="visible"
      :scmCode="scmCode"
      :visitCode="visitCode"
      @colse="() => (visible = false)"
    />
  </div>
</template>
<script>
import AddScoreDialog from './components/add-score-dialog.vue'
export default {
  mixins: [],
  props: {
    scmCode: {
      type: String,
      default: () => '',
    },
    visitCode: {
      type: String,
      default: () => '',
    },
  },
  components: { AddScoreDialog },
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.getData(),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
          fixed: 'left',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.label_operation') || '操作',
          align: 'center',
          width: 100,
          fixed: 'left',
          slots: {
            default: 'opt',
          },
        },
        {
          field: 'scoreByName',
          width: 200,
          title: this.$l('appraise_form_label_evaluator') || '评分人',
          slots: { default: 'defaultImgUrl' },
          headerAlign: 'center',
        },
        {
          align: 'center',
          field: 'scoreTime',
          width: 180,
          title: this.$l('appraise_table_label_evaluation_time') || '评分时间',
        },
        {
          field: 'score',
          width: 150,
          align: 'center',
          title: this.$l('appraise_table_label_score') || '得分',
        },
        {
          field: 'appraisalBillName',
          minWidth: 300,
          title: this.$l('label_appraisal_bill_name') || '评分模板',
          headerAlign: 'center',
        },
      ],
      loading: false,
      tableData: [],

      visible: false,
    }
  },
  watch: {
    scmCode: {
      handler() {
        this.getData()
      },
      immediate: true,
    },
  },
  activated() {
    this.getData()
  },
  methods: {
    getData() {
      if (this.scmCode === '' || this.visitCode === '') return
      this.loading = true
      this.$api
        .getVisitScoreListApi({
          scmCode: this.scmCode,
          visitCode: this.visitCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
        .catch(() => {
          this.loading = false
        })
    },
    openDetail(visitScoreCode) {
      this.$router.push({
        name: 'personal-myScmInfo-myVisit-rating-edit',
        params: {
          pageType: 'edit',
          visitScoreCode: visitScoreCode,
        },
      })
    },
    del(code) {
      let msg = this.$l('INDEX.tips_question_delete') || '是否删除?'

      this.$confirm(msg, this.$l('INDEX.tips_question_title') || '提示', {
        confirmButtonText: this.$l('INDEX.tips_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.tips_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api.delVisitScoreApi({ visitScoreCode: code }).then(() => {
          this.$message.success(this.$l('INDEX.tips_operate_ok') || '操作成功!')
          this.getData()
        })
      })
    },
  },
}
</script>
